import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../../lib";
export class ApiEpBillingProductPostsPackage {
}
ApiEpBillingProductPostsPackage.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/posts-package/`,
    method: "GET",
    query: req === null || req === void 0 ? void 0 : req.query,
});
ApiEpBillingProductPostsPackage.purchase = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/posts-package/${req.path.id}/purchase`,
    method: "POST",
});
ApiEpBillingProductPostsPackage.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/posts-package/${req.path.id}`,
    method: "GET",
});
//# sourceMappingURL=posts_package.js.map